import { useContext } from "react";

import SnackbarContext from "./snackbar-context";

export const useSnackbar = () => useContext(SnackbarContext);
